/**
 * Navigation breakpoints.
 */
module.exports = {
  'xs': 480,
  'sm': 769,
  'md': 992,
  'lg': 1200
};
